import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Wizard from '../components/preset/Wizard';
import { PageHeader, PageTitle } from '../components/common/PageElements';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
`;

const CreatePresetPage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Create New Preset</PageTitle>
      </PageHeader>
      
      <Wizard />
    </PageContainer>
  );
};

export default CreatePresetPage; 